import WindowService from '@src/services/window.service';
import { getUserAgent } from '@src/helpers/user-agent.helper';
import { reportError, addAction } from '@src/vendor/dynatrace';

export enum NativeMobileAppMessages {
  BACK = 'back_button_pressed',
  CLEAR_HISTORY = 'clear_history_stack',
}

/**
 * send an event to NMA with predetermined message codes
 */
export const sendJsBridgeEventMessage = (message: NativeMobileAppMessages) => {
  // based on the UserAgentType, isIOS and isAndroid will never both be true
  const { isIOS, isAndroid } = getUserAgent();

  if (typeof window === 'undefined') return;

  try {
    if (isIOS) {
      if (
        WindowService.window?.webkit?.messageHandlers
          ?.pet_insurance_nma_hybrid_bridge
      ) {
        WindowService.window?.webkit?.messageHandlers.pet_insurance_nma_hybrid_bridge.postMessage(
          message,
        );
        console.info(
          `pet_insurance_nma_hybrid_bridge - ${message} - iOS event was sent`,
        );
      } else {
        console.warn(
          'pet_insurance_nma_hybrid_bridge - iOS bridge was not defined',
        );
      }
    }

    if (isAndroid) {
      if (WindowService.window?.pet_insurance_nma_hybrid_bridge) {
        WindowService.window.pet_insurance_nma_hybrid_bridge.postMessage(
          message,
        );
        console.info(
          `pet_insurance_nma_hybrid_bridge - ${message} - android event was sent`,
        );
      } else {
        console.warn(
          `pet_insurance_nma_hybrid_bridge - android bridge was not defined`,
        );
      }
    }
  } catch (error) {
    reportError(error as Error);
    addAction('Attempt to send js-bridge-event failed');
  }
};
